import { render, staticRenderFns } from "./RecommendPurchased.vue?vue&type=template&id=12ab9ed8&scoped=true&"
import script from "./RecommendPurchased.vue?vue&type=script&lang=js&"
export * from "./RecommendPurchased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab9ed8",
  null
  
)

export default component.exports